
import type {
  ArrayConfigFieldData,
  ArrayConfigFieldSchema,
  ConfigFieldData,
  ConfigFieldSchema,
  ObjectConfigFieldData,
  ObjectConfigFieldSchema,
} from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { ServiceConfigFieldMessages } from '../../models'

import { ConfigFieldTypeEnum } from '@empathyco/playboard-core-domain'

import { defineComponent } from 'vue'

import { InstanceManagementUtils } from '../../utils'

export default defineComponent({
  name: 'ObjectArrayServiceConfigFieldValueItem',
  props: {
    valueItem: {
      type: Object as PropType<ObjectConfigFieldData>,
      required: true,
    },
    schema: {
      type: Object as PropType<ObjectConfigFieldSchema>,
      required: true,
    },
    messages: {
      type: Object as PropType<Record<string, ServiceConfigFieldMessages>>,
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-object-array-service-config-field-value-item',
      ConfigFieldTypeEnum,
    }
  },
  computed: {
    visiblePropertyIds(): string[] {
      return InstanceManagementUtils.getObjectServiceConfigFieldVisiblePropertyIds(this.schema)
    },
  },
  methods: {
    getPropertyLabel(propertyId: string): string {
      return (
        this.messages?.[propertyId]?.label ||
        this.schema.properties[propertyId].front_metadata?.display_name ||
        propertyId
      )
    },
    getPropertyValueHtml(value: ConfigFieldData, schema: ConfigFieldSchema): string {
      if ((!value && value !== false) || (Array.isArray(value) && !value.length)) {
        return '-'
      }
      const typeFn = {
        [ConfigFieldTypeEnum.OBJECT]: () => {
          const objectSchema = schema as ObjectConfigFieldSchema
          const visiblePropertyIds =
            InstanceManagementUtils.getObjectServiceConfigFieldVisiblePropertyIds(objectSchema)
          return visiblePropertyIds
            .reduce((result: string[], propertyId: string) => {
              result.push(
                this.getPropertyValueHtml(value[propertyId], objectSchema.properties[propertyId]),
              )
              return result
            }, [])
            .join(' | ')
        },
        [ConfigFieldTypeEnum.ARRAY]: () => {
          const arraySchema = schema as ArrayConfigFieldSchema
          const arrayValue = value as ArrayConfigFieldData
          return arrayValue
            .map(valueItem => this.getPropertyValueHtml(valueItem, arraySchema.items))
            .join(', ')
        },
      }[schema.type]
      return typeFn ? typeFn() : value.toString()
    },
  },
})
